import type { Image } from 'cms-types'

import LoadingText from '../../components/LoadingText'
import { PayloadImage } from '../../components/PayloadImage'
import type { LoadableComponentProps } from '../../types'

interface ClubPointsProps {
  points: number
  title: string
  subtitle: string
  pointsLabel: string
  nextTierLabel?: string
  tierText: string
  level: string
  image?: Image
}

export default function ClubPoints({ data, loading }: LoadableComponentProps<ClubPointsProps>) {
  const {
    points = 0,
    title,
    subtitle,
    pointsLabel,
    nextTierLabel,
    tierText,
    level,
    image,
  } = data || {}

  return (
    <div className='w-full overflow-hidden bg-steelblue'>
      <section className='relative w-full text-white'>
        <PayloadImage
          src={image}
          sizes='100vw'
          objectFit='cover'
          className='!absolute inset-0'
          showPlaceholder={loading}
        />

        <div className='relative mx-auto max-w-4xl px-6 py-20 text-center'>
          <h1 className='h2 tracking-wide'>{loading ? <LoadingText textLength={20} /> : title}</h1>
          <p className='md mt-3 text-white'>
            {loading ? <LoadingText textLength={80} lines={2} /> : subtitle}
          </p>
        </div>
      </section>

      <section className='relative flex w-full flex-col items-end gap-10 px-6 pb-16 pt-14 text-center md:flex-row md:gap-4'>
        <div className='mx-auto flex max-w-3xl flex-col items-center justify-center'>
          <p className='md'>{loading ? <LoadingText textLength={6} /> : tierText}</p>
          <span className='h2 text-highlight' data-testid='club-tier-name'>
            {loading ? <LoadingText textLength={5} /> : level}
          </span>
        </div>
        <div className='mx-auto flex max-w-3xl flex-col items-center justify-center'>
          <div>
            <span className='h2 mr-1 inline-block text-highlight' data-testid='club-points-value'>
              {loading ? <LoadingText textLength={3} /> : points}
            </span>
            <span className='h6 inline-block tracking-wide'>
              {loading ? <LoadingText textLength={6} /> : pointsLabel}
            </span>
          </div>
          {nextTierLabel && (
            <p className='md' data-testid='club-next-tier-label'>
              {loading ? <LoadingText textLength={20} /> : nextTierLabel}
            </p>
          )}
        </div>
      </section>
    </div>
  )
}
